export const DATE_FORMAT = 'yyyy-MM-dd';

export const TIME_FORMAT_OUTPUT = 'MM/dd/yyyy';

export const NOT_SELECTED = '---';
export const defaultDayTime = {
  start: '07:00',
  end: '07:00',
};
